
import React from 'react';
import Header from './Header';
import MobileNav from './MobileNav';
import { useIsMobile } from '@/hooks/use-mobile';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-4 md:py-6 animate-fade-in overflow-y-auto pb-24 md:pb-6">
        {children}
      </main>
      {isMobile && <MobileNav />}
    </div>
  );
};

export default Layout;
